import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { AuthLoginFlag } from 'src/app/components/shared/sharedModules/auth/models/auth-login.flags.enum';

@Component({
  selector: 'app-auth-login-create-form',
  templateUrl: './auth-login-create-form.component.html',
  styleUrls: ['./auth-login-create-form.component.sass']
})
export class AuthLoginCreateFormComponent implements OnInit {

  @Output() eventSubmit = new EventEmitter();
  @Output() eventShowPassword = new EventEmitter();
  @Output() eventRemember = new EventEmitter();
  @Input() isChecked: boolean;
  @Input() loginForm: UntypedFormGroup;
  @Input() showLoginLoading: boolean;
  @Input() flagList: Flags<AuthLoginFlag>;
  flagListEnum = AuthLoginFlag;

  constructor() { /** */ }

// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void { /** */ }

}
